import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { LOCAL_TZ } from "Consts";
import FlyoutForm from "components/Forms/FlyoutForm";
import authTypes from "reduxStore/auth/auth.types";
import { authSelector } from "reduxStore/auth/auth.selectors";
import AuthenticationService from "services/AuthService/Authentication";
import Users from "services/UsersService/Users";
import { isSubjectAuthorizedForUser } from "utils";
import { Roles, Subjects } from "settings/permissions";

const MyProfile = ({ onClose }: any) => {
  const dispatch = useDispatch();
  const { currentUser } = useSelector(authSelector, shallowEqual);
  currentUser.timezone = currentUser.timezone ?? LOCAL_TZ;

  const canEditUserProfile = isSubjectAuthorizedForUser({
    subject: Subjects.User_Profile,
    role: Roles.Write,
  });

  const upsertUser = (object: any, selectedTab: any) => {
    if (selectedTab === "Info") {
      object.updateDate = currentUser?.updateDate; // object from flyout is out of sync with currentUser;
      //@ts-ignore
      const promise = Users.updateSelf(object);
      promise.then((result) => {
        AuthenticationService.getCurrentUserInfo().then((userResponse) => {
          // will be refreshed by the cache sync hub
          if (userResponse && userResponse.data) {
            dispatch({
              type: authTypes.SET_CURRENT_USER,
              payload: { currentUser: { ...currentUser, ...userResponse.data } },
            });
          }
        });

        if (!result?.errors) {
          result = null;
          onClose();
        }
      });
    } else if (selectedTab === "Password") {
      Users.changePassword(object).then((result) => {});
    }
  };

  useEffect(() => {
    AuthenticationService.getCurrentUserInfo().then((userResponse) => {
      // will be refreshed by the cache sync hub
      if (userResponse && userResponse.data) {
        dispatch({
          type: authTypes.SET_CURRENT_USER,
          payload: { currentUser: { ...currentUser, ...userResponse.data } },
        });
      }
    });
  }, []);

  return (
    <>
      <FlyoutForm
        cancelHandler={onClose}
        saveHandler={upsertUser}
        source={currentUser}
        readonly={!canEditUserProfile}
        tabs={
          [
            {
              name: "Info",
              isProfile: true,
              controls: [
                {
                  field: "firstName",
                  inputType: "text",
                  label: "First Name",
                  required: true,
                  validation: "firstName",
                },
                {
                  field: "lastName",
                  inputType: "text",
                  label: "Last Name",
                  required: true,
                  validation: "lastName",
                },
                {
                  field: "preferredName",
                  inputType: "text",
                  label: "Preferred Name",
                  validation: "preferredName",
                },
                {
                  field: "title",
                  inputType: "text",
                  label: "Title",
                  validation: "userTitle",
                },
                {
                  field: "city",
                  inputType: "text",
                  label: "City",
                  validation: "city",
                },
                {
                  fdType: "usStates",
                  field: "state",
                  inputType: "select",
                  label: "State",
                },
                {
                  field: "officeNumber",
                  inputType: "phone",
                  label: "Office Phone",
                  validation: "phone",
                },
                {
                  field: "cellNumber",
                  inputType: "phone",
                  label: "Mobile Phone",
                  validation: "phone",
                },
                {
                  field: "emailAddress",
                  inputType: "text",
                  label: "Email",
                  required: true,
                  validation: "email",
                },
              ],
            },
            // {
            //   name: "Password",
            //   controls: [
            //     {
            //       field: "currentPassword",
            //       inputType: "password",
            //       label: "Current Password",
            //       required: true,
            //     },
            //     {
            //       field: "confirmPassword1",
            //       inputType: "password",
            //       label: "New Password",
            //       required: true,
            //       validation: "password",
            //     },
            //     {
            //       field: "confirmPassword2",
            //       inputType: "password",
            //       label: "Confirm New Password",
            //       required: true,
            //       validation: "password",
            //       mustMatchExactField: "confirmPassword1",
            //     },
            //   ],
            // },
          ].filter((tab) => tab.name !== "Password" || canEditUserProfile) as any
        }
        tabsValidationShared={false}
        title={canEditUserProfile ? "Edit Profile" : "Profile"}
      />
    </>
  );
};

export default MyProfile;
